<style scoped>
  .backgroundImage{
    width: 24px;
    height: 24px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
  }
</style>
<template>
    <el-menu-item v-if="!menuItem.treeNodes.length" :index="menuItem.channel.url.replace(/(\s*$)/g, '')">
        <i :class="menuItem.channel.imgPath?'el-icon-img backgroundImage':'el-icon-document'" :style='menuItem.channel.imgPath?`background-image:url(${menuItem.channel.imgPath})`:""'></i>
        <span>{{menuItem.channel.name}}</span>
    </el-menu-item>
    <el-submenu v-else :index="menuItem.channel.keyword">
        <template slot="title">
          <i :class="menuItem.channel.imgPath?'el-icon-img backgroundImage':'el-icon-folder'" :style='menuItem.channel.imgPath?`background-image:url(${menuItem.channel.imgPath})`:""'></i>
          <span>{{menuItem.channel.name}}</span>
        </template>
        <MainMenu v-for="(item,index) in menuItem.treeNodes" :key="index" :menuItem="item" />
      </el-submenu>
</template>

<script>
export default {
  name: 'MainMenu',
  data(){
      return{
      }
  },
  props: {
    menuItem:Object,
    level:Number 
  },
}
</script>
